import { IHttpInterceptor, IHttpResponse, IRequestConfig } from "angular";
import moment from "moment";
import { interceptorFactory } from "../angular-core";
import { angularServicesNames } from "@topline/services/angularServicesNames";

type ErrorMessageBody = {
    type: string;
    data: {
        forecastName: string;
        oracleIndex: string;
        forecastStartDate: string;
        rowIndex: number;
        missingData: string[];
    };
};

class HttpShowErrorInterceptor implements IHttpInterceptor {
    static $inject = ["AlertService", angularServicesNames.$translate];
    static componentName = "httpShowErrorInterceptor";

    constructor(private alertService: AlertService, private $translate: ng.translate.ITranslateService
    ) {}

    request(config: IRequestConfig) {
        return config;
    }

    requestError(rejection: $TSFixMe) {
        return rejection;
    }

    response = <T>(response: IHttpResponse<T>) => {
        if (response.status == 500) {
            const errorMessage = response.data as ErrorMessageBody;
            var message = this.$translate.instant("GENERIC_ERROR");

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("SupervisorNotFoundException") >= 0
            ) {
                message = this.$translate.instant("NO_GM_IN_PANDL");
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("OracleIndexAlreadyForecastedException") >= 0
            ) {
                var forecastName = errorMessage.data.forecastName;
                var oracleIndex = errorMessage.data.oracleIndex;
                message =
                    this.$translate.instant("FORECAST_ACCEPTANCE.ORACLE_INDEX_NOT_UNIQUE_1") +
                    oracleIndex +
                    this.$translate.instant("FORECAST_ACCEPTANCE.ORACLE_INDEX_NOT_UNIQUE_2") +
                    forecastName +
                    this.$translate.instant("FORECAST_ACCEPTANCE.ORACLE_INDEX_NOT_UNIQUE_3");
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("RollingForecastNotFinishedException") >= 0
            ) {
                var oracleIndex = errorMessage.data.oracleIndex;

                var forecastStartDate = moment.utc(errorMessage.data.forecastStartDate);
                message = this.$translate.instant(
                    "ROLLING_FORECAST.FORECAST.GROUP_EDIT.ROLLING_FORECAST_NOT_FINISHED",
                    {
                        oracleIndex,
                        forecastStartDate: forecastStartDate.format("MM-YYYY")
                    }
                );
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("InvalidFileFormatException") >= 0
            ) {
                message = this.$translate.instant("FORECAST_LIST.MASTER_P_L_FORMAT_ERROR", {
                    row: errorMessage.data.rowIndex
                });
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("NotAllOraleIndexesHasRollingForecastException") >= 0
            ) {
                message = this.$translate.instant(
                    "ROLLING_FORECAST.FORECAST.ORACLE_EXPORT.NOT_ALL_IN_GROUP_HAS_FORECAST"
                );
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("CannotExportRFIfAlreadyPresentInExportTableException") >= 0
            ) {
                message = this.$translate.instant("ROLLING_FORECAST.FORECAST.ORACLE_EXPORT.FORECAST_ALREADY_PRESENT");
            }

            if (
                angular.isUndefinedOrNull(errorMessage.type) == false &&
                errorMessage.type.indexOf("IncompleteForecastException") >= 0
            ) {
                const obj = {
                    missingData: errorMessage.data.missingData
                        .map(md => this.$translate.instant(`FORECAST_ACCEPTANCE.MISSING_DATA.${md}`))
                        .join(", ")
                };
                message = this.$translate.instant("FORECAST_ACCEPTANCE.NOT_COMPLETED", obj);
            }

            this.alertService.error(message);
        } else if (response.status == 403) {
            this.alertService.warning(this.$translate.instant("UNAUTHORIZED_OPERATION"));
        }

        return response;
    }
    responseError<T>(rejection: $TSFixMe) {
        return rejection;
    }
}

angular
    .module("topline.services")
    .factory(HttpShowErrorInterceptor.componentName, interceptorFactory(HttpShowErrorInterceptor))
    .config([
        "$httpProvider",
        function ($httpProvider: ng.IHttpProvider) {
            $httpProvider.interceptors.push(HttpShowErrorInterceptor.componentName);
        }
    ]);
